module.exports = __webpack_public_path__ + "static/media/Muli-Regular.a401afc3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli/Muli-Regular.ttf
// module id = 1294
// module chunks = 1